import React from "react";
import { IconName } from "components/icon/Icon";
import { Button, ButtonVariants } from "components/button";
import { KebabCase } from "utils/types";
import { cn } from "utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/ui/tooltip";

export interface ActionCardActionProps {
  iconName: KebabCase<IconName>;
  iconClassName?: string;
  variant?: ButtonVariants;
  testId?: string;
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  actionOnHover?: boolean;
}

export const ActionCardAction: React.FC<ActionCardActionProps> = ({
  iconName,
  iconClassName,
  variant = "link",
  label,
  onClick,
  disabled,
  testId,
  actionOnHover = false,
}) => {
  return (
    <div>
      <Tooltip>
        <TooltipTrigger asChild tabIndex={-1}>
          <Button
            icon={iconName}
            variant={variant}
            className={cn(
              "flex items-center justify-center h-10 w-10 p-0",
              actionOnHover &&
                "opacity-0 group-hover:opacity-100 transition-opacity",
              iconClassName,
            )}
            onClick={(e) => {
              if (onClick) {
                e.stopPropagation();
                onClick();
              }
            }}
            testId={testId}
            aria-label={label}
            disabled={disabled}
          />
        </TooltipTrigger>
        <TooltipContent side="top" align="end">
          <p>{label}</p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
};
